// DS: i6.22
import React from 'react';
import IconWrap from '../../IconWrap';
const AddEmoticon = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16zm4 10a4 4 0 01-7.995.2L8 14h8zM9.5 9a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm5 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"
    })));
};
AddEmoticon.displayName = 'AddEmoticon';
export default AddEmoticon;

//# sourceMappingURL=AddEmoticon.js.map